import React from 'react';
import './styles.css';

const UsersDataTables = ({ data1 = [], data2 = [], table1, table2, groupBy }) => {

  const formatDateLabel = (x) => {
    if (!x) return '';

    if (groupBy === 'day') {
      const parts = x.split("-");
      const day = parts[2];
      const month = parseInt(parts[1], 10);
      const monthNames = [
        "enero","febrero","marzo","abril","mayo","junio",
        "julio","agosto","septiembre","octubre","noviembre","diciembre"
      ];
      return `${day}/${monthNames[month - 1]}`;
    }

    if (groupBy === 'month') {
      const parts = x.split("-");
      const month = parseInt(parts[1], 10);
      const monthNames = [
        "enero","febrero","marzo","abril","mayo","junio",
        "julio","agosto","septiembre","octubre","noviembre","diciembre"
      ];
      return monthNames[month - 1];
    }

    if (groupBy === 'week') {
      const parts = x.split("-");
      const weekNumber = parts.length > 1 ? parts[1] : x;
      return `week - ${weekNumber}`;
    }

    if (groupBy === 'quarter') {
      const q = x.includes("Q") ? x.split("Q")[1] : x;
      return `quarter ${q}`;
    }

    if (groupBy === 'semester') {
      const s = x.includes("S") ? x.split("S")[1] : x;
      return `semester ${s}`;
    }

    if (groupBy === 'year') {
      return x;
    }

    return x; // fallback
  };

  const transformData = (data) => {
    // Si existe 'year' usamos años, si no usamos 'label'
    const columnKeys = data[0]?.year ? 
      Array.from(new Set(data.map(d => d.year))).sort() : 
      Array.from(new Set(data.map(d => d.label))).sort();

    const grouped = {};
    data.forEach(d => {
      if (!grouped[d.x]) grouped[d.x] = {};
      const key = d.year ?? d.label; // priorizamos year, si no existe usamos label
      grouped[d.x][key] = (grouped[d.x][key] || 0) + d.y;
    });

    return {
      transformed: Object.keys(grouped).map(date => {
        const row = { date: formatDateLabel(date) };
        columnKeys.forEach(key => {
          row[key] = grouped[date][key] || 0;
        });
        return row;
      }),
      columns: columnKeys
    };
  };

  const renderTable = (data, tableName) => {
    const { transformed, columns } = transformData(data);

    return (
      <div className="users-data-table">
        <h4>{tableName}</h4>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              {columns.map(col => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {transformed.map((row, idx) => (
              <tr key={idx}>
                <td>{row.date}</td>
                {columns.map(col => (
                  <td key={col}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="users-data-container">
      {renderTable(data1, table1)}
      {renderTable(data2, table2)}
    </div>
  );
};

export default UsersDataTables;
